import styles from "./ProgressBar.module.scss";

const ProgressBar = ({ progress = 0, height = 6, color = "#FF603E" }) => {
  const normalizedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div className={styles.progressContainer} style={{ height: `${height}px` }}>
      <div
        className={styles.progressBar}
        style={{
          width: `${normalizedProgress}%`,
          backgroundColor: color
        }}
      />
    </div>
  );
};

export default ProgressBar;
